export enum WithdrawalType {
    online = 'online',
    instant = 'instant',
    bankTransfer = 'bankTransfer',
    shop = 'shop',
    paySafeCard = 'paySafeCard',
}

export enum DepositType {
    online = 'online',
    bankTransfer = 'bankTransfer',
    shop = 'shop',
    paySafeCard = 'paySafeCard',
}

export enum NotificationType {
    idCard = 'idCard',
    completeRegistration = 'completeRegistration',
    sms = 'sms',
    lowBalance = 'lowBalance',
    idCardVerificationPending = 'idCardVerificationPending',
    idCardVerificationApproved = 'idCardVerificationApproved',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/user/enums.ts